import { Icon } from '@chakra-ui/react';

export const ChevronRightIcon = () => {
	return (
		<Icon
			w="11"
			h="19"
			viewBox="0 0 11 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.74349 1.8125L9.91016 9.8125L1.74349 17.8125"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
